import React from 'react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import DeleteOrCancel from '@/components/buttons/DeleteOrCancel';
import Actions from '@/components/buttons/Actions';
import { eventSubscriptions } from '../constants';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const SubscriberConfirmationDialog = ({ theme }) => {
  const intl = useIntl();
  const { event, isSubscribed, saveStatus } = Selectors.useSubscriberConfirmationDialog();
  const hide = Events.useToggleShowSubscription();
  const toggle = Events.useToggleSubscription(eventSubscriptions.USERS_REGISTERED);

  const titleId = isSubscribed
    ? `events.${event}.unsubscribe.dialog.title`
    : `events.${event}.subscribe.dialog.title`;

  const contentId = isSubscribed
    ? `events.${event}.unsubscribe.dialog.content`
    : `events.${event}.subscribe.dialog.content`;

  return (
    <DialogWrapper
      className="aridhia-subscriber-confirmation-dialog"
      icon="send"
      message={contentId}
      title={intl.formatMessage({ id: titleId })}
      theme={theme}
    >
      {isSubscribed && (
        <DeleteOrCancel
          deleteMessageId="subscriptions.unsubscribe"
          deleteIcon="eye slash"
          inProgress={saveStatus === states.PENDING}
          minimumDataEntryMet
          onClose={hide}
          onDelete={toggle}
        />
      )}
      {!isSubscribed && (
        <Actions
          inProgress={saveStatus === states.PENDING}
          minimumDataEntryMet
          onClose={hide}
          onSave={toggle}
          saveIcon="eye"
          saveMessageId="subscriptions.subscribe"
        />
      )}
    </DialogWrapper>
  );
};

export default SubscriberConfirmationDialog;
